import { SentenceSet, TextSet, WordSet } from '@/stores/store.types';

export const isExerciseSet = (
  set: any,
): set is WordSet | SentenceSet | TextSet => {
  return (
    set.exerciseClass === 'word' ||
    set.exerciseClass === 'sentence' ||
    set.exerciseClass === 'text'
  );
};

export const isWordSet = (
  set: WordSet | SentenceSet | TextSet,
): set is WordSet => {
  return set.exerciseClass === 'word';
};

export const isSentenceSet = (
  set: WordSet | SentenceSet | TextSet,
): set is SentenceSet => {
  return set.exerciseClass === 'sentence';
};

export const isTextSet = (
  set: WordSet | SentenceSet | TextSet,
): set is TextSet => {
  return set.exerciseClass === 'text';
};
